import { render, staticRenderFns } from "./CompanyInfo_BasicData.vue?vue&type=template&id=5ecac118&scoped=true"
import script from "./CompanyInfo_BasicData.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_BasicData.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo_BasicData.vue?vue&type=style&index=0&id=5ecac118&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecac118",
  null
  
)

export default component.exports